import { createSlice } from '@reduxjs/toolkit'
import { ASIDE_CONST } from './consts'

interface AsideState {
  open: boolean
}

const initialState = { open: false } as AsideState

const asideSlice = createSlice({
  name: ASIDE_CONST,
  initialState,
  reducers: {
    openAside(state) {
      state.open = true
    },
    closeAside(state) {
      state.open = false
    },
  },
})

export const { openAside, closeAside } = asideSlice.actions
export default asideSlice.reducer
